export default __webpack_public_path__ + "static/media/ubicacion_IES_eng.ecef4ed3.jpg";